module.exports = __webpack_public_path__ + "static/media/coaching.69ad6929.webp";